import React, { useEffect, useState } from "react";
import { useTheme } from "../config/ThemeContext";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const SetDurationDialog = ({ show, matchId, currentSet, setDuration, setSetDuration, onConfirm, matchOver = false, }) => {
  const theme = useTheme();
  const [summaryHTML, setSummaryHTML] = useState("");

  useEffect(() => {
    if (show) {
      fetch(`${baseUrl}/reports/match/${matchId}/set-summary`)
        .then(res => res.text())
        .then(html => setSummaryHTML(html))
        .catch(err => console.error("Error loading summary:", err));
    }
  }, [show, matchId]);

  if (!show) return null;

  const handleButtonClick = () => {
    if (matchOver) {
      // Just close the dialog in this scenario
      // Option 1: Hide the dialog by calling onConfirm(0) or something
      onConfirm(0); 
      // or you could define a separate prop if you prefer a more explicit naming
    } else {
      // Existing logic: pass setDuration back to onConfirm
      onConfirm(setDuration);
    }
  };

  return (
    <div className={`fixed top-24 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-5xl mx-auto p-6 rounded-lg shadow-xl border ${theme.primary.border} ${theme.secondary.lightBg}`}>
      <h2 className={`text-2xl font-semibold mb-4 text-center ${theme.primary.text}`}>
        Set {currentSet} Summary
      </h2>

      {/* 🔥 Injected Handlebars HTML */}
      <div
        className="match-summary-html"
        dangerouslySetInnerHTML={{ __html: summaryHTML }}
      />

      <div className="flex justify-center">
         <button
          onClick={handleButtonClick}
          className={`px-6 py-2 rounded font-medium text-white ${theme.primary.bg} ${theme.primary.hover}`}
        >
          {matchOver ? "Close" : "Confirm and Start Next Set"}
        </button>
      </div>
    </div>
  );
};

export default SetDurationDialog;
